// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Show = require("../Data.Show/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Html_Parser = require("../Html.Parser/index.js");
var Text_Parsing_StringParser = require("../Text.Parsing.StringParser/index.js");
var htmlAttributeToProp = function (v) {
    return Halogen_HTML_Properties.attr(v.value0)(v.value1);
};
var nodeToHtml = function (v) {
    if (v instanceof Html_Parser.HtmlElement) {
        return elementToHtml(v.value0);
    };
    if (v instanceof Html_Parser.HtmlText) {
        return Halogen_HTML_Core.text(v.value0);
    };
    if (v instanceof Html_Parser.HtmlComment) {
        return Halogen_HTML_Core.text("");
    };
    throw new Error("Failed pattern match at Html.Renderer.Halogen (line 34, column 1 - line 34, column 50): " + [ v.constructor.name ]);
};
var elementToHtml = function (ele) {
    var children = Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Functor.map(Data_List_Types.functorList)(nodeToHtml)(ele.children));
    return Halogen_HTML_Elements.element(ele.name)(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Functor.map(Data_List_Types.functorList)(htmlAttributeToProp)(ele.attributes)))(children);
};
var parse = function (raw) {
    return Data_Bifunctor.lmap(Data_Either.bifunctorEither)(Data_Show.show(Text_Parsing_StringParser.showParseError))(Data_Functor.map(Data_Either.functorEither)((function () {
        var $9 = Data_Array.fromFoldable(Data_List_Types.foldableList);
        var $10 = Data_Functor.map(Data_List_Types.functorList)(nodeToHtml);
        return function ($11) {
            return $9($10($11));
        };
    })())(Html_Parser.parse(raw)));
};
var renderToArray = function (raw) {
    return Data_Either.either(function (err) {
        return [ Halogen_HTML_Core.text(err) ];
    })(Control_Category.identity(Control_Category.categoryFn))(parse(raw));
};
var render = function (props) {
    var $12 = Halogen_HTML_Elements.div(props);
    return function ($13) {
        return $12(renderToArray($13));
    };
};
var render_ = render([  ]);
module.exports = {
    htmlAttributeToProp: htmlAttributeToProp,
    elementToHtml: elementToHtml,
    nodeToHtml: nodeToHtml,
    parse: parse,
    render_: render_,
    render: render,
    renderToArray: renderToArray
};
